import React from 'react'

const NoDataFoundMessage = ({ message = 'Dados indisponíveis' }) => {
  return <div style={{ margin: '5px 0', fontSize: '1.4rem' }}>{message}</div>
}

export default NoDataFoundMessage
